import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/stockSlice";
import stockApis from "src/api/stock";
import { common } from "src/types";
import { constants } from "src/constants/common";

// ✅ Get Stock Level List Saga
function* GetStockLevelListSaga({
  payload,
}: ReturnType<typeof actions.getStockLevelListRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      stockApis.getStockLevels,
      payload
    );
    yield put(actions.getStockLevelListSuccess(response));
  } catch (error) {
    yield put(
      actions.getStockLevelListError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Adjust Stock Saga
function* AdjustStockSaga({
  payload,
}: ReturnType<typeof actions.adjustStockRequest> & { payload: any }) {
  try {
    const response: common.ResponseGenerator = yield call(
      stockApis.adjustStock,
      payload
    );
    yield put(actions.adjustStockSuccess(response));
  } catch (error) {
    yield put(
      actions.adjustStockError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Get Stock Transfer List Saga
function* GetStockTransferListSaga({
  payload,
}: ReturnType<typeof actions.getStockTransferListRequest> & {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      stockApis.getStockTransfers,
      payload
    );
    yield put(actions.getStockTransferListSuccess(response));
  } catch (error) {
    yield put(
      actions.getStockTransferListError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

// ✅ Create Stock Transfer Saga
function* CreateStockTransferSaga({
  payload,
}: ReturnType<typeof actions.createStockTransferRequest> & {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      stockApis.createStockTransfer,
      payload
    );
    yield put(actions.createStockTransferSuccess(response));
  } catch (error) {
    yield put(
      actions.createStockTransferError(
        error instanceof Error
          ? error.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
  }
}

export default function* stockSaga() {
  yield all([
    takeEvery(actions.getStockLevelListRequest, GetStockLevelListSaga),
    takeEvery(actions.adjustStockRequest, AdjustStockSaga),
    takeEvery(actions.getStockTransferListRequest, GetStockTransferListSaga),
    takeEvery(actions.createStockTransferRequest, CreateStockTransferSaga),
  ]);
}
